export const USER_PROFILE_UPDATED = "USER_PROFILE_UPDATED";
export const USER_PROFILE_CLEARED = "USER_PROFILE_CLEARED";
